module.exports = __webpack_public_path__ + "img/mascot-change-pass.578bda05.svg";